var _defs, _g, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    zoomAndPan: "magnify",
    viewBox: "0 0 75 74.999997",
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.40625 11 L 73.398438 11 L 73.398438 75 L 1.40625 75 Z M 1.40625 11 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#090a0b",
    d: "M 73.398438 49.441406 C 69.71875 60.933594 60.410156 70.394531 47.777344 73.753906 C 28.117188 78.96875 7.925781 67.414062 2.664062 47.910156 C -1.050781 34.125 3.699219 20.035156 13.789062 11.132812 C 11.742188 17.539062 11.46875 24.585938 13.351562 31.5625 C 18.605469 51.0625 38.804688 62.628906 58.460938 57.414062 C 64.191406 55.882812 69.25 53.09375 73.398438 49.441406 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#090a0b",
    d: "M 34.316406 5.613281 C 37.695312 16.449219 35.546875 14.355469 46.472656 17.679688 C 35.546875 20.996094 37.695312 18.902344 34.316406 29.734375 C 30.96875 18.902344 33.074219 20.992188 22.15625 17.679688 C 33.074219 14.355469 30.96875 16.449219 34.316406 5.613281 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#090a0b",
    d: "M 56.050781 23.851562 C 58.332031 31.199219 56.890625 29.769531 64.292969 32.027344 C 56.890625 34.289062 58.332031 32.859375 56.050781 40.199219 C 53.808594 32.863281 55.214844 34.292969 47.847656 32.027344 C 55.214844 29.769531 53.808594 31.199219 56.050781 23.851562 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#090a0b",
    d: "M 52 0.00390625 C 54.277344 7.339844 52.835938 5.917969 60.207031 8.140625 C 52.839844 10.398438 54.28125 8.976562 52 16.316406 C 49.722656 8.976562 51.160156 10.398438 43.761719 8.140625 C 51.160156 5.917969 49.722656 7.34375 52 0.00390625 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#090a0b",
    d: "M 36.324219 45.054688 C 37.160156 45.054688 37.835938 45.722656 37.835938 46.582031 C 37.835938 47.417969 37.160156 48.109375 36.324219 48.109375 C 35.457031 48.109375 34.785156 47.417969 34.785156 46.582031 C 34.785156 45.71875 35.457031 45.054688 36.324219 45.054688 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#090a0b",
    d: "M 25.207031 30.5625 C 26.582031 30.5625 27.648438 31.660156 27.648438 32.992188 C 27.648438 34.355469 26.578125 35.414062 25.207031 35.414062 C 23.867188 35.414062 22.757812 34.355469 22.757812 32.992188 C 22.757812 31.664062 23.867188 30.5625 25.207031 30.5625 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonIcon);
export default __webpack_public_path__ + "static/media/moon-icon.b8ad731ab3bb1e04e981f4653ef428f2.svg";
export { ForwardRef as ReactComponent };